import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";


const UserProfilePageComponent = ({ updateUserApiRequest, fetchUser, userInfoFromRedux, setReduxUserState, reduxDispatch, localStorage, sessionStorage }) => {
  const [validated, setValidated] = useState(false);
  const [updateUserResponseState, setUpdateUserResponseState] = useState({ success: "", error: "" });
  const [passwordsMatchState, setPasswordsMatchState] = useState(true);
  const [user, setUser] = useState({})
  const userInfo = userInfoFromRedux;

  useEffect(() => {
      fetchUser(userInfo._id)
      .then((data) => setUser(data))
      .catch((er) => console.log(er));
  }, [userInfo._id])

  const onChange = () => {
    const password = document.querySelector("input[name=password]");
    const confirmPassword = document.querySelector("input[name=confirmPassword]");
    if (confirmPassword.value === password.value) {
      setPasswordsMatchState(true);
    } else {
      setPasswordsMatchState(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget.elements;

    const name = form.name.value;
    const lastName = form.lastName.value;
    const phoneNumber = form.phoneNumber.value;
    const address = form.address.value;
    const country = form.country.value;
    const zipCode = form.zipCode.value;
    const city = form.city.value;
    const state = form.state.value;
    const password = form.password.value;

    if (event.currentTarget.checkValidity() === true && form.password.value === form.confirmPassword.value) {
        updateUserApiRequest(name, lastName, phoneNumber, address, country, zipCode, city, state, password).then(data => {
            setUpdateUserResponseState({ success: data.success, error: "" });
            reduxDispatch(setReduxUserState({ doNotLogout: userInfo.doNotLogout, ...data.userUpdated }));
            if (userInfo.doNotLogout) localStorage.setItem("userInfo", JSON.stringify({ doNotLogout: true, ...data.userUpdated }));
            else sessionStorage.setItem("userInfo", JSON.stringify({ doNotLogout: false, ...data.userUpdated }));
        })
        .catch((er) => setUpdateUserResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data }))
    }

    setValidated(true);
  };
  return (

    <Container className="px-0"
      style={{
        background:	'#35353a',
        maxWidth: '100%'
      }}   
    >

      <Row className="mt-5 justify-content-md-center">
        <Col md={6}>
          
          <h1
            style={{
              color: "white",
              }}
            >
            Modifica il tuo Profilo
          </h1>

          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="validationCustom01">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Nome</Form.Label>
              <Form.Control
                required
                type="text"
                defaultValue={user.name}
                name="name"
              />
              <Form.Control.Feedback type="invalid">
                inserisci il nome
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicLastName">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Cognome
              </Form.Label>
              <Form.Control
                required
                type="text"
                defaultValue={user.lastName}
                name="lastName"
              />
              <Form.Control.Feedback type="invalid">
                inserisci il cognome
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Email
              </Form.Label>
              <Form.Control
                disabled
                value={user.email + "   se desideri modificare l'email, rimuovi l'account e creane uno nuovo con un nuovo indirizzo email"}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPhone">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Telefono
                </Form.Label>
              <Form.Control
                type="text"
                placeholder="inserisci il tuo numero di telefono"
                defaultValue={user.phoneNumber}
                name="phoneNumber"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicAddress">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Indirizzo
                </Form.Label>
              <Form.Control
                type="text"
                placeholder="inserisci via e numero"
                defaultValue={user.address}
                name="address"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicCountry">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Provincia
                </Form.Label>
              <Form.Control
                type="text"
                placeholder="inserisci la Provincia"
                defaultValue={user.country}
                name="country"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicZip">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Cap
                </Form.Label>
              <Form.Control
                type="text"
                placeholder="inserisci il CAP"
                defaultValue={user.zipCode}
                name="zipCode"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicCity">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Città
                </Form.Label>
              <Form.Control
                type="text"
                placeholder="inserisci la Città"
                defaultValue={user.city}
                name="city"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicState">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Nazione
                </Form.Label>
              <Form.Control
                type="text"
                placeholder="inserisci il Nazione"
                defaultValue={user.state} 
                name="state"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Password
                </Form.Label>
              <Form.Control
                name="password"
                required
                type="password"
                placeholder="Password"
                minLength={6}
                onChange={onChange}
                isInvalid={!passwordsMatchState}
              />
              <Form.Control.Feedback type="invalid">
                inserisci una password valida
              </Form.Control.Feedback>
              <Form.Text className="text-muted">
                la password deve contenere almeno 6 caratteri
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPasswordRepeat">
              <Form.Label
                style={{
                  color: "white",
                  }}
                >
                Ripeti Password
                </Form.Label>
              <Form.Control
                name="confirmPassword"
                required
                type="password"
                placeholder="repeti la Password"
                minLength={6}
                onChange={onChange}
                isInvalid={!passwordsMatchState}
              />
              <Form.Control.Feedback type="invalid">
                le password devono corrispondere
              </Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit">
              Modifica
            </Button>
            <Alert show={updateUserResponseState && updateUserResponseState.error !== ""} variant="danger">
              Qualcosa è andato storto
            </Alert>
            <Alert show={updateUserResponseState && updateUserResponseState.success === "user updated"} variant="info">
              Utente modificato
            </Alert>
          </Form>
        </Col>
      </Row>
      <Row className="mt-5 justify-content-md-center">
        <Col md={6}>
        </Col>
      </Row>
    </Container>
  );
};

export default UserProfilePageComponent;
